module.exports = __webpack_public_path__ + "static/img/4.b317c63c.png";